// companyReducer.js

import {
  GET_COMPANY_REQUEST,
  GET_COMPANY_SUCCESS,
  GET_COMPANY_FAILURE,
} from "./actionsTypes";

const initialState = {
  company: {},
  loading: false,
  error: null,
};

const companyReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_COMPANY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        company: action.payload,
      };
    case GET_COMPANY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "SET_COMPANY":
      return {
        ...state,
        company: action.payload,
      };
    default:
      return state;
  }
};

export default companyReducer;
